(function($) {
	$(document).ready(function() {
		var $bar = $('.accessibility-content-bar');

		if (!$bar.length) {
			return;
		}

		var $text = $bar.find('.accessibility-content-bar-text');
		var isActive = false;
		var currentIndex = 0;
		var firstActive = false;
		var content = [
			{ text: $bar.data('skip-content'), href: '#main-content' }
		];

		if ($('#main-menu-id').length) {
			content.push({ text: $bar.data('skip-menu'), href: '#main-menu-id' });
		}

		content.push({ text: $bar.data('skip-footer'), href: '#footer-anchor' });

		function updateText() {
			var item = content[currentIndex];
			$text.text(item.text).attr('href', item.href);
		}

		function hideBar() {
			isActive = false;
			$bar.removeClass('-active');
		}

		function showBar() {
			isActive = true;
			currentIndex = 0;
			$bar.addClass('-active');
			updateText();
			$text.focus();
		}

		function scrollToAnchor(href) {
			var $target = $(href);

			if (!$target.length) {
				return;
			}

			$('html, body').animate({ scrollTop: $target.offset().top }, 400, function() {
				$target.attr('tabindex', '-1').focus();
			});
		}

		$('body').on('keydown', function(e) {
			if (e.key == 'Tab') {
				if (!isActive && firstActive === false) {
					if (document.activeElement === document.body) {
						firstActive = true;
						e.preventDefault();
						showBar();
					}
				} else if (isActive) {
					if (e.shiftKey) {
						if (currentIndex > 0) {
							e.preventDefault();
							currentIndex--;
							updateText();
						} else if (currentIndex === 0) {
							hideBar();
						}
					} else if (currentIndex < content.length - 1) {
						e.preventDefault();
						currentIndex++;
						updateText();
					} else {
						hideBar();
					}
				}
			}

			if (e.key == 'Enter' && isActive) {
				e.preventDefault();
				hideBar();
				scrollToAnchor($text.attr('href'));
			}

			if (e.key == 'Escape' && isActive) {
				hideBar();
			}
		});

		$text.on('click', function(e) {
			e.preventDefault();
			hideBar();
			scrollToAnchor($(this).attr('href'));
		});

		$(window).on('scroll', function() {
			if (isActive) {
				hideBar();
			}
		});
	});
})(jQuery);
